<div class="nav_container">
  <ul>
    <div class="mb-4">
      <li class="uppercase text-greyLighter text-sm font-bold mb-1">Outils</li>
      <li>
        <a
          [routerLink]="['agenda/gestionnaire']"
          class="nav_item"
          routerLinkActive="active-link"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path
              fill="#E5E8EC"
              stroke="black"
              stroke-width="6"
              d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z"
            />
          </svg>
          <span class="ml-3">Mon Agenda</span>
        </a>
      </li>
      <li>
        <a
          class="nav_item"
          routerLinkActive="active-link"
          [routerLink]="['agenda']"
          [routerLinkActiveOptions]="{ exact: true }"
          style="padding-left: 11px"
        >
          <svg
            style="width: 24px; height: 22px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="message-dots-circle">
              <path
                id="Icon"
                d="M7.5 12H7.51M12 12H12.01M16.5 12H16.51M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 13.1971 3.23374 14.3397 3.65806 15.3845C3.73927 15.5845 3.77988 15.6845 3.798 15.7653C3.81572 15.8443 3.8222 15.9028 3.82221 15.9839C3.82222 16.0667 3.80718 16.1569 3.77711 16.3374L3.18413 19.8952C3.12203 20.2678 3.09098 20.4541 3.14876 20.5888C3.19933 20.7067 3.29328 20.8007 3.41118 20.8512C3.54589 20.909 3.73218 20.878 4.10476 20.8159L7.66265 20.2229C7.84309 20.1928 7.9333 20.1778 8.01613 20.1778C8.09715 20.1778 8.15566 20.1843 8.23472 20.202C8.31554 20.2201 8.41552 20.2607 8.61549 20.3419C9.6603 20.7663 10.8029 21 12 21ZM8 12C8 12.2761 7.77614 12.5 7.5 12.5C7.22386 12.5 7 12.2761 7 12C7 11.7239 7.22386 11.5 7.5 11.5C7.77614 11.5 8 11.7239 8 12ZM12.5 12C12.5 12.2761 12.2761 12.5 12 12.5C11.7239 12.5 11.5 12.2761 11.5 12C11.5 11.7239 11.7239 11.5 12 11.5C12.2761 11.5 12.5 11.7239 12.5 12ZM17 12C17 12.2761 16.7761 12.5 16.5 12.5C16.2239 12.5 16 12.2761 16 12C16 11.7239 16.2239 11.5 16.5 11.5C16.7761 11.5 17 11.7239 17 12Z"
                stroke="#E5E8EC"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
          </svg>
          <span class="ml-2">Activités</span>
        </a>
      </li>
      <li>
        <a
          [routerLink]="['documents']"
          class="nav_item"
          routerLinkActive="active-link"
        >
          <svg
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 18"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M10 16.5c0-1-8-2.7-9-2V1.8c1-1 9 .707 9 1.706M10 16.5V3.506M10 16.5c0-1 8-2.7 9-2V1.8c-1-1-9 .707-9 1.706"
            />
          </svg>
          <span class="ml-3">Mes documents</span>
        </a>
      </li>
      <ng-container>
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">AMI</li>
      </ng-container>
      <ng-container>
        <li>
          <a
            [routerLink]="['ami/paiementetat']"
            class="nav_item"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
            style="padding-left: 8px"
          >
            <svg
              version="1.1"
              viewBox="0 0 18.6 12.9"
              style="width: 28px; height: 22px"
            >
              <g>
                <g id="Calque_1">
                  <path
                    fill="#F3F4F6"
                    d="M2,.9c-.6,0-1.1.5-1.1,1.1v7.7c0,.6.5,1.1,1.1,1.1h8.9c.1,0,.3-.1.3-.3h0c0-.1-.1-.3-.3-.3H2c-.3,0-.6-.3-.6-.6v-4.6h13v.3c0,.1.1.3.3.3h0c.1,0,.3-.1.3-.3,0,0,0,0,0,0V2c0-.6-.5-1.1-1.1-1.1H2ZM2,1.4h11.8c.3,0,.6.3.6.6v1.2H1.4v-1.2c0-.3.3-.6.6-.6ZM1.4,3.7h13v.8H1.4v-.8ZM14.6,6.1c-1.8,0-3.2,1.4-3.2,3.2s1.4,3.2,3.2,3.2,3.2-1.4,3.2-3.2-1.4-3.2-3.2-3.2ZM14.6,6.6c1.5,0,2.7,1.2,2.7,2.7s-1.2,2.7-2.7,2.7-2.7-1.2-2.7-2.7,1.2-2.7,2.7-2.7ZM2.9,7.1c-.1,0-.3.1-.3.3v1.6c0,.1.1.3.3.3h2.4c.1,0,.3-.1.3-.3v-1.6c0-.1-.1-.3-.3-.3h-2.4ZM3.1,7.6h1.8v1h-1.8v-1ZM15.8,8.2c0,0-.1,0-.2,0l-1.4,1.4-.7-.7c-.1-.1-.3-.1-.4,0,0,0,0,0,0,0-.1.1-.1.3,0,.4,0,0,0,0,0,0l.9.9c.1.1.3.1.4,0,0,0,0,0,0,0l1.6-1.6c.1-.1,0-.3,0-.4,0,0,0,0,0,0,0,0-.1,0-.2,0h0Z"
                  />
                </g>
              </g>
            </svg>
            <span class="ml-2"> Paiement des États</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['ami/listecompany']"
            class="nav_item"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              viewBox="0 0 110 109.9"
              style="width: 22px; height: 22px"
            >
              <g>
                <g id="Calque_1">
                  <path
                    fill="#F3F4F6"
                    d="M34.2,10.1c.6-.6,1.3-.9,2.1-.9h47.5c5.6,0,10.2,4.6,10.2,10.2v73.2c0,5.6-4.6,10.2-10.2,10.2H26.2c-5.6,0-10.2-4.6-10.2-10.2V29.5l.5-1.6,17.7-17.8ZM37.1,51.1h35.8c3.9,0,3.9-6,0-6h-35.8c-3.9,0-3.9,6,0,6ZM45,85.1h19.9c3.9,0,3.9-6,0-6h-19.9c-3.9,0-3.9,6,0,6ZM37.1,68.1h35.8c3.9,0,3.9-6,0-6h-35.8c-3.9,0-3.9,6,0,6ZM22,32.5v60.1c0,2.3,1.9,4.2,4.2,4.2h57.6c2.3,0,4.2-1.9,4.2-4.2V19.4c0-2.3-1.9-4.2-4.2-4.2h-44.5v14.3c0,1.7-1.3,3-3,3h-14.3ZM33.3,26.5v-7l-7,7h7Z"
                  />
                </g>
              </g>
            </svg>

            <span class="ml-2">Liste des documents</span>
          </a>
        </li>
      </ng-container>
      <ng-container class="nav_container ml-1">
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">
          Mentorat
        </li>
        <div class="mb-4">
          <ul>
            <li>
              <a
                [routerLink]="['mentorat/paiement']"
                class="nav_item"
                routerLinkActive="active-link"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <svg
                  style="margin-left: -5px; width: 24px; height: 24px"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <rect x="3" y="7" width="18" height="10" rx="2" ry="2" />
                  <line x1="3" y1="11" x2="21" y2="11" />
                  <line x1="7" y1="15" x2="9" y2="15" />
                  <circle cx="18" cy="7" r="3" />
                  <path d="M16.5 7.5l1 1 2-2" />
                </svg>
                <span class="ml-3">Gestion Paiements</span>
              </a>
            </li>
          </ul>
        </div>
      </ng-container>
      <li class="uppercase text-greyLighter text-sm font-bold mb-1">
        demandes de paiements
      </li>
      <div class="mb-4">
        <ul>
          <li>
            <a
              [routerLink]="['gestion-finance/dossier-partenaire']"
              class="nav_item"
              routerLinkActive="active-link"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <svg
                style="margin-left: -5px; width: 24px; height: 24px"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ffffff"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect x="3" y="7" width="18" height="10" rx="2" ry="2" />
                <line x1="3" y1="11" x2="21" y2="11" />
                <line x1="7" y1="15" x2="9" y2="15" />
                <circle cx="18" cy="7" r="3" />
                <path d="M16.5 7.5l1 1 2-2" />
              </svg>
              <span class="ml-3">Gestion Documents</span>
            </a>
          </li>
        </ul>
      </div>
      <ng-container>
        <li class="uppercase text-greyLighter text-sm font-bold mb-1 mt-3">
          Accompagnement
        </li>
      </ng-container>
      <ng-container>
        <li>
          <a class="nav_item" [href]="urlFondAmorcage" target="_blank">
            <svg
              height="24"
              width="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 3h10a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4V3z"
                fill="#E5E8EC"
              />
              <path
                d="M13 12h7m0 0l-3-3m3 3l-3 3"
                stroke="#FFFFFF"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <span class="ml-3">Connexion</span>
          </a>
        </li>
      </ng-container>
    </div>
  </ul>
</div>
